<template lang="pug">
  .container
    .columns
      .column.is-3
        .field
          label.label Destino
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="ubicacion")
                option(value="") Selecciona el Destino
                option(value="IRGE") IRGE
                option(value="TPA") TPA
                option(value="CORP") CORPORATIVO
                option(value="EB04") EB04
                option(value="EB03") EB03
                option(value="EB02") EB02
                option(value="EB01") EB01
                option(value="EB00") EB00
                option(value="ERM") ERM-TLAUTLA
                option(value="LPGD") Válvulas
            .icon.is-small.is-left
              i.fas.fa-map-pin
      .column.is-3
        .field
          label.label Usuario a Reasignar
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="usuarioSel")
                option(value="") Selecciona el Destino
                option(v-for="user in usuariosShow" :value="user") {{user.nombre}}
            .icon.is-small.is-left
              i.fas.fa-user
      .column.is-3
        .field
          label.label Oficina
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="oficinaSel")
                option(value="") Selecciona el Destino
                option(v-for="ofi in oficinasShow" :value="ofi") {{ofi.nombre}}
            .icon.is-small.is-left
              i.far.fa-building
      .column.is-3
        .field
          label.label Selecciona el Área
            .control
              input#area_Inst.is-checkradio(type='radio' v-model="area" value="1" name='sel_area' checked='checked')
              label.is-size-6(for='area_Inst') Instrum.
              input#area_Sist.is-checkradio(type='radio' v-model="area" value="3" name='sel_area')
              label.is-size-6(for='area_Sist') Sist./Telec.
    .columns
      .column.is-4.is-offset-4
        a.button.is-dark.is-rounded(@click="saveReasignacion")
          i.fas.fa-save
          | &nbsp Guardar Reasignación
</template>

<script>
import InventarioServices from '../../services/inventario/inventario'
import moment from 'moment'
import { mapState } from 'vuex'

  export default {
    name: 'FormCambioAsignacion',
    props: {
      usuarios: {
        type: Array,
        default: []
      },
      items: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        ubicacion: '',
        usuarioSel: {},
        area: '',
        oficinas: [
          { 'id': 'TPA-ALM', 'nombre': 'Almacén', 'source': 'TPA' },
          { 'id': 'TPA-ALS', 'nombre': 'Almacén Sist.', 'source': 'TPA' },
          { 'id': 'TPA-ADM', 'nombre': 'Of. Admin.', 'source': 'TPA' },
          { 'id': 'TPA-CC', 'nombre': 'Cuarto de Control', 'source': 'TPA' },
          { 'id': 'TPA-SERV', 'nombre': 'Servidores', 'source': 'TPA' },
          { 'id': 'TPA-IO', 'nombre': 'Cuarto de IOS', 'source': 'TPA' },
          { 'id': 'TPA-FAC', 'nombre': 'Facturación', 'source': 'TPA' },
          { 'id': 'TPA-BAS', 'nombre': 'Báscula', 'source': 'TPA' },
          { 'id': 'TPA-GER', 'nombre': 'Gerencia', 'source': 'TPA' },
          { 'id': 'TPA-MUE', 'nombre': 'Muelle', 'source': 'TPA' },
          { 'id': 'TPA-MANT', 'nombre': 'Subgerencia de Mntto.', 'source': 'TPA' },
          { 'id': 'TPA-TALL', 'nombre': 'Taller de Mntto.', 'source': 'TPA' },
          { 'id': 'TPA-SEG', 'nombre': 'Subgerencia de Seguridad', 'source': 'TPA' },
          { 'id': 'TPA-SADM', 'nombre': 'Subgerencia Administrativa', 'source': 'TPA' },
          { 'id': 'TPA-PROP', 'nombre': 'Of. Propangol', 'source': 'TPA' },
          { 'id': 'TPA-NIE', 'nombre': 'Of. Nieto', 'source': 'TPA' },
          { 'id': 'TPA-MOV', 'nombre': 'Of. Movenergy', 'source': 'TPA' },
          { 'id': 'TPA-SJ', 'nombre': 'Sala de Juntas', 'source': 'TPA' },
          { 'id': 'TPA-ACC', 'nombre': 'Accesos', 'source': 'TPA' },
          { 'id': 'TPA-VIG', 'nombre': 'Vigilancia', 'source': 'TPA' },
          { 'id': 'TPA-ESF', 'nombre': 'Esféricos', 'source': 'TPA' },
          { 'id': 'TPA-LLEN', 'nombre': 'Llenaderas', 'source': 'TPA' },
          { 'id': 'TPA-SJ2', 'nombre': 'Sala de Juntas 2', 'source': 'TPA' },
          { 'id': 'TPA-REC', 'nombre': 'Recepción', 'source': 'TPA' },
          { 'id': 'TPA-COM', 'nombre': 'Comedor', 'source': 'TPA' },
          { 'id': 'TPA-SALM', 'nombre': 'SubAlmacén', 'source': 'TPA' },
          { 'id': 'TPA-TRE', 'nombre': 'Área 300', 'source': 'TPA' },
          { 'id': 'IRGE-ALM', 'nombre': 'Almacén', 'source': 'IRGE' },
          { 'id': 'IRGE-ADM', 'nombre': 'Of. Admin.', 'source': 'IRGE' },
          { 'id': 'IRGE-CC', 'nombre': 'Cuarto de Control', 'source': 'IRGE' },
          { 'id': 'IRGE-FAC', 'nombre': 'Facturación', 'source': 'IRGE' },
          { 'id': 'IRGE-BAS', 'nombre': 'Báscula', 'source': 'IRGE' },
          { 'id': 'IRGE-GER', 'nombre': 'Gerencia', 'source': 'IRGE' },
          { 'id': 'IRGE-GADM', 'nombre': 'Gerencia Admn.', 'source': 'IRGE' },
          { 'id': 'IRGE-SJ', 'nombre': 'Sala de Juntas', 'source': 'IRGE' },
          { 'id': 'IRGE-SEG', 'nombre': 'Of. Seguridad', 'source': 'IRGE' },
          { 'id': 'IRGE-IOS', 'nombre': 'Cuarto de IOS', 'source': 'IRGE' },
          { 'id': 'IRGE-PEM', 'nombre': 'Of. Pemex', 'source': 'IRGE' },
          { 'id': 'IRGE-ACC', 'nombre': 'Accesos', 'source': 'IRGE' },
          { 'id': 'IRGE-VIG', 'nombre': 'Vigilancia', 'source': 'IRGE' },
          { 'id': 'IRGE-CE', 'nombre': 'Cuarto Eléctrico', 'source': 'IRGE' },
          { 'id': 'IRGE-REC', 'nombre': 'Recepción', 'source': 'IRGE' },
          { 'id': 'IRGE-OP', 'nombre': 'Operación', 'source': 'IRGE' },
          { 'id': 'IRGE-CCP', 'nombre': 'Cuarto Control Plus', 'source': 'IRGE' },
          { 'id': 'IRGE-VP', 'nombre': '23 Puntos', 'source': 'IRGE' },
          { 'id': 'IRGE-MOV', 'nombre': 'Movenergy', 'source': 'IRGE' },
          { 'id': 'IRGE-VIC', 'nombre': 'Vigilanca CUSAEM', 'source': 'IRGE' },
          { 'id': 'IRGE-OFE', 'nombre': 'Oficina Eléctrica', 'source': 'IRGE' },
          { 'id': 'EB04-ALG', 'nombre': 'Almacén S & I', 'source': 'EB04' },
          { 'id': 'EB04-CC', 'nombre': 'Cuarto de Control', 'source': 'EB04' },
          { 'id': 'EB04-ADM', 'nombre': 'Of. Admin.', 'source': 'EB04' },
          { 'id': 'EB04-GER', 'nombre': 'Gerencia', 'source': 'EB04' },
          { 'id': 'EB04-SIS', 'nombre': 'Sistemas', 'source': 'EB04' },
          { 'id': 'EB04-INS', 'nombre': 'Instrumentación', 'source': 'EB04' },
          { 'id': 'EB04-VIG', 'nombre': 'Vigilancia', 'source': 'EB04' },
          { 'id': 'EB04-SG', 'nombre': 'Sala de Juntas', 'source': 'EB04' },
          { 'id': 'EB04-TIA', 'nombre': 'Taller Inst/Aut', 'source': 'EB04' },
          { 'id': 'EB04-ALM', 'nombre': 'Almacén', 'source': 'EB04' },
          { 'id': 'EB03-CC', 'nombre': 'Cuarto de Control', 'source': 'EB03' },
          { 'id': 'EB03-ADM', 'nombre': 'Of. Admin.', 'source': 'EB03' },
          { 'id': 'EB03-VIG', 'nombre': 'Vigilancia', 'source': 'EB03' },
          { 'id': 'EB03-ARC', 'nombre': 'Archivo', 'source': 'EB03' },
          { 'id': 'EB03-COM', 'nombre': 'Comedor', 'source': 'EB03' },
          { 'id': 'EB03-REC', 'nombre': 'Recepción', 'source': 'EB03' },
          { 'id': 'EB03-SJ', 'nombre': 'Sala de Juntas', 'source': 'EB03' },
          { 'id': 'EB03-SV', 'nombre': 'Servicios', 'source': 'EB03' },
          { 'id': 'EB03-TAL', 'nombre': 'Taller', 'source': 'EB03' },
          { 'id': 'EB03-ALM', 'nombre': 'Almacén', 'source': 'EB03' },
          { 'id': 'EB02-CC', 'nombre': 'Cuarto de Control', 'source': 'EB02' },
          { 'id': 'EB02-ADM', 'nombre': 'Of. Admin.', 'source': 'EB02' },
          { 'id': 'EB02-VIG', 'nombre': 'Vigilancia', 'source': 'EB02' },
          { 'id': 'EB02-ARC', 'nombre': 'Archivo', 'source': 'EB02' },
          { 'id': 'EB02-COM', 'nombre': 'Comedor', 'source': 'EB02' },
          { 'id': 'EB02-REC', 'nombre': 'Recepción', 'source': 'EB02' },
          { 'id': 'EB02-SJ', 'nombre': 'Sala de Juntas', 'source': 'EB02' },
          { 'id': 'EB02-ALM', 'nombre': 'Almacén', 'source': 'EB02' },
          { 'id': 'EB01-CC', 'nombre': 'Cuarto de Control', 'source': 'EB01' },
          { 'id': 'EB01-ADM', 'nombre': 'Of. Admin.', 'source': 'EB01' },
          { 'id': 'EB01-VIG', 'nombre': 'Vigilancia', 'source': 'EB01' },
          { 'id': 'EB01-ARC', 'nombre': 'Archivo', 'source': 'EB01' },
          { 'id': 'EB01-COM', 'nombre': 'Comedor', 'source': 'EB01' },
          { 'id': 'EB01-REC', 'nombre': 'Recepción', 'source': 'EB01' },
          { 'id': 'EB01-SJ', 'nombre': 'Sala de Juntas', 'source': 'EB01' },
          { 'id': 'EB01-ALM', 'nombre': 'Almacén', 'source': 'EB01' },
          { 'id': 'EB00-CC', 'nombre': 'Cuarto de Control', 'source': 'EB00' },
          { 'id': 'EB00-ADM', 'nombre': 'Of. Admin.', 'source': 'EB00' },
          { 'id': 'EB00-VIG', 'nombre': 'Vigilancia', 'source': 'EB00' },
          { 'id': 'EB00-ALM', 'nombre': 'Almacén', 'source': 'EB00' },
          { 'id': 'EB00-ARC', 'nombre': 'Archivo', 'source': 'EB00' },
          { 'id': 'EB00-COM', 'nombre': 'Comedor', 'source': 'EB00' },
          { 'id': 'EB00-SV', 'nombre': 'Servicios', 'source': 'EB00' },
          { 'id': 'ERM-CC', 'nombre': 'Cuarto de Control', 'source': 'ERM' },
          { 'id': 'ERM-ADM', 'nombre': 'Of. Admin.', 'source': 'ERM' },
          { 'id': 'ERM-VIG', 'nombre': 'Vigilancia', 'source': 'ERM' },
          { 'id': 'ERM-ALM', 'nombre': 'Almacén', 'source': 'ERM' },
          { 'id': 'VALV-ADM', 'nombre': 'Gabinete', 'source': 'LPGD' },
          { 'id': 'CORP-DIR', 'nombre': 'Dirección', 'source': 'CORP' },
          { 'id': 'CORP-GG', 'nombre': 'Gerencia Gral.', 'source': 'CORP' },
          { 'id': 'CORP-GC', 'nombre': 'Gerencia de Contraloría', 'source': 'CORP' },
          { 'id': 'CORP-C', 'nombre': 'Contabilidad', 'source': 'CORP' },
          { 'id': 'CORP-CP', 'nombre': 'Cuentas por Pagar', 'source': 'CORP' },
          { 'id': 'CORP-F', 'nombre': 'Fiscal', 'source': 'CORP' },
          { 'id': 'CORP-SA', 'nombre': 'Seguimiento Amb.', 'source': 'CORP' },
          { 'id': 'CORP-GR', 'nombre': 'Gerencia de Reg.', 'source': 'CORP' },
          { 'id': 'CORP-ALM', 'nombre': 'Almacén', 'source': 'CORP' },
          { 'id': 'CORP-ALG', 'nombre': 'Almacén GIA', 'source': 'CORP' },
          { 'id': 'CORP-GIS', 'nombre': 'Gerencia Inst. y Sist.', 'source': 'CORP' },
          { 'id': 'CORP-SIT', 'nombre': 'Site', 'source': 'CORP' },
          { 'id': 'CORP-RH', 'nombre': 'Recursos Humanos', 'source': 'CORP' },
          { 'id': 'CORP-LEG', 'nombre': 'Legal', 'source': 'CORP' },
          { 'id': 'CORP-REC', 'nombre': 'Recepción', 'source': 'CORP' },
          { 'id': 'CORP-AUD', 'nombre': 'Auditoría', 'source': 'CORP' },
          { 'id': 'CORP-TES', 'nombre': 'Tesorería', 'source': 'CORP' },
          { 'id': 'CORP-GEN', 'nombre': 'General', 'source': 'CORP' },
          { 'id': 'LPGD-V1', 'nombre': 'Válvula 1', 'source': 'LPGD' },
          { 'id': 'LPGD-V2', 'nombre': 'Válvula 2', 'source': 'LPGD' },
          { 'id': 'LPGD-V3', 'nombre': 'Válvula 3', 'source': 'LPGD' },
          { 'id': 'LPGD-V4', 'nombre': 'Válvula 4', 'source': 'LPGD' },
          { 'id': 'LPGD-V5', 'nombre': 'Válvula 5', 'source': 'LPGD' },
          { 'id': 'LPGD-V6', 'nombre': 'Válvula 6', 'source': 'LPGD' },
          { 'id': 'LPGD-V7', 'nombre': 'Válvula 7', 'source': 'LPGD' },
          { 'id': 'LPGD-V8', 'nombre': 'Válvula 8', 'source': 'LPGD' },
          { 'id': 'LPGD-V9', 'nombre': 'Válvula 9', 'source': 'LPGD' },
          { 'id': 'LPGD-V10', 'nombre': 'Válvula 10', 'source': 'LPGD' },
          { 'id': 'LPGD-V11', 'nombre': 'Válvula 11', 'source': 'LPGD' },
          { 'id': 'LPGD-V12', 'nombre': 'Válvula 12', 'source': 'LPGD' },
          { 'id': 'LPGD-V13', 'nombre': 'Válvula 13', 'source': 'LPGD' },
          { 'id': 'LPGD-V14', 'nombre': 'Válvula 14', 'source': 'LPGD' },
          { 'id': 'LPGD-V15', 'nombre': 'Válvula 15', 'source': 'LPGD' },
          { 'id': 'LPGD-V16', 'nombre': 'Válvula 16', 'source': 'LPGD' },
          { 'id': 'LPGD-V17', 'nombre': 'Válvula 17', 'source': 'LPGD' },
          { 'id': 'LPGD-V18', 'nombre': 'Válvula 18', 'source': 'LPGD' },
          { 'id': 'LPGD-V19', 'nombre': 'Válvula 19', 'source': 'LPGD' },
          { 'id': 'LPGD-V20', 'nombre': 'Válvula 20', 'source': 'LPGD' },
          { 'id': 'LPGD-V21', 'nombre': 'Válvula 21', 'source': 'LPGD' },
          { 'id': 'LPGD-V22', 'nombre': 'Válvula 22', 'source': 'LPGD' },
          { 'id': 'LPGD-V23', 'nombre': 'Válvula 23', 'source': 'LPGD' },
          { 'id': 'LPGD-V24', 'nombre': 'Válvula 24', 'source': 'LPGD' },
          { 'id': 'LPGD-V25', 'nombre': 'Válvula 25', 'source': 'LPGD' },
          { 'id': 'LPGD-V26', 'nombre': 'Válvula 26', 'source': 'LPGD' },
          { 'id': 'LPGD-V1B', 'nombre': 'Válvula 1 BIS', 'source': 'LPGD' },
          { 'id': 'LPGD-V2B', 'nombre': 'Válvula 2 BIS', 'source': 'LPGD' },
          { 'id': 'LPGD-V3B', 'nombre': 'Válvula 3 BIS', 'source': 'LPGD' },
          { 'id': 'LPGD-V4B', 'nombre': 'Válvula 4 BIS', 'source': 'LPGD' },
          { 'id': 'LPGD-V5B', 'nombre': 'Válvula 5 BIS', 'source': 'LPGD' },
          { 'id': 'LPGD-INT', 'nombre': 'Interconexión', 'source': 'LPGD' },
          { 'id': 'TPA-RV', 'nombre': 'Recuperador de vapores', 'source': 'TPA'},
          { 'id': 'TPA-PM', 'nombre': 'Paquete de Medición', 'source': 'TPA'},
          { 'id': 'TPA-BP', 'nombre': 'Bombas de Proceso', 'source': 'TPA'},
          { 'id': 'TPA-SISV', 'nombre': 'Sistema Vickers', 'source': 'TPA'},
          { 'id': 'TPA-SCI', 'nombre': 'Sist. Contra Incendio', 'source': 'TPA'},
          { 'id': 'TPA-CB', 'nombre': 'Cuarto de Baterias', 'source': 'TPA'},
          { 'id': 'EB00-BP', 'nombre': 'Bombas de Proceso', 'source': 'EB00'},
          { 'id': 'EB00-CB', 'nombre': 'Cuarto de Baterias', 'source': 'EB00'},
          { 'id': 'EB00-PM', 'nombre': 'Patín de Medición', 'source': 'EB00'},
          { 'id': 'EB00-TD', 'nombre': 'Trampa de Diablos', 'source': 'EB00'},
          { 'id': 'EB00-TR', 'nombre': 'Tren de Regulación', 'source': 'EB00'},
          { 'id': 'ERM-PM', 'nombre': 'Patín de Medición', 'source': 'ERM'},
          { 'id': 'ERM-SAL', 'nombre': 'Salida IRGE', 'source': 'ERM'},
          { 'id': 'ERM-TD', 'nombre': 'Trampa de Diablos', 'source': 'ERM'},
          { 'id': 'ERM-TP', 'nombre': 'Tanque Pulmón', 'source': 'ERM'},
          { 'id': 'ERM-TPRG', 'nombre': 'Tanque de Purga', 'source': 'ERM'},
          { 'id': 'ERM-TR', 'nombre': 'Tren de Regulación', 'source': 'ERM'},
          { 'id': 'ERM-JEF', 'nombre': 'Jefatura', 'source': 'ERM'},
          { 'id': 'ERM-COM', 'nombre': 'Comedor', 'source': 'ERM'},
          { 'id': 'ERM-CEL', 'nombre': 'Cuarto Eléctrico', 'source': 'ERM'},
          { 'id': 'EB04-BP', 'nombre': 'Bombas de Proceso', 'source': 'EB04'},
          { 'id': 'EB04-CAB', 'nombre': 'Cabezales', 'source': 'EB04'},
          { 'id': 'EB04-CB', 'nombre': 'Cobertizo de Bombas', 'source': 'EB04'},
          { 'id': 'EB04-COC', 'nombre': 'Cocina', 'source': 'EB04'},
          { 'id': 'EB04-CTE', 'nombre': 'Cuarto Eléctrico', 'source': 'EB04'},
          { 'id': 'EB04-GEN', 'nombre': 'Generadores', 'source': 'EB04'},
          { 'id': 'EB04-PM', 'nombre': 'Patín de Medición', 'source': 'EB04'},
          { 'id': 'EB04-RP', 'nombre': 'Residuos Peligrosos', 'source': 'EB04'},
          { 'id': 'EB04-TALL', 'nombre': 'Taller y Almacén', 'source': 'EB04'},
          { 'id': 'EB04-TD', 'nombre': 'Trampa de Diablos', 'source': 'EB04'},
          { 'id': 'EB04-TORG', 'nombre': 'Tanque de Purga', 'source': 'EB04'},
          { 'id': 'EB04-TR', 'nombre': 'Tren de Regulación', 'source': 'EB04'},
          { 'id': 'EB04-TRA', 'nombre': 'Transformador', 'source': 'EB04'},
          { 'id': 'IRGE-BOM', 'nombre': 'Bombas LPG', 'source': 'IRGE'},
          { 'id': 'IRGE-BP', 'nombre': 'Bombas de Proceso', 'source': 'IRGE'},
          { 'id': 'IRGE-CB', 'nombre': 'Cuarto de Bombas', 'source': 'IRGE'},
          { 'id': 'IRGE-CCM', 'nombre': 'CCM', 'source': 'IRGE'},
          { 'id': 'IRGE-CI', 'nombre': 'Red C.I.', 'source': 'IRGE'},
          { 'id': 'IRGE-COMP', 'nombre': 'Area de Compresores', 'source': 'IRGE'},
          { 'id': 'IRGE-CONT', 'nombre': 'Contabilidad', 'source': 'IRGE'},
          { 'id': 'IRGE-CUB', 'nombre': 'Cubeta', 'source': 'IRGE'},
          { 'id': 'IRGE-ESF', 'nombre': 'Esferas', 'source': 'IRGE'},
          { 'id': 'IRGE-LLEN', 'nombre': 'Llenaderas', 'source': 'IRGE'},
          { 'id': 'IRGE-MANT', 'nombre': 'Of. Mantenimiento', 'source': 'IRGE'},
          { 'id': 'IRGE-PROP', 'nombre': 'Of. Propangol', 'source': 'IRGE'},
          { 'id': 'IRGE-TA', 'nombre': 'Tanque de Agua', 'source': 'IRGE'},
          { 'id': 'IRGE-TD', 'nombre': 'Trampa de Diablos', 'source': 'IRGE'},
          { 'id': 'IRGE-TP', 'nombre': 'Tanque Pulmón', 'source': 'IRGE'},
          { 'id': 'IRGE-TR', 'nombre': 'Tren de Regulación', 'source': 'IRGE'},
          { 'id': 'IRGE-TRA', 'nombre': 'Area de Trasiegos', 'source': 'IRGE'},
          { 'id': 'IRGE-TALL', 'nombre': 'Taller', 'source': 'IRGE'},
        ],
        oficinaSel: {},
        usuariosShow: [],
        oficinasShow: [],
        itemsSaved: 0
      }
    },
    watch: {
      ubicacion() {
        this.oficinasShow = this.oficinas.filter( ofi => ofi.source === this.ubicacion)
        this.usuariosShow = this.usuarios.filter( user => user.ubicacion === this.ubicacion)
      }
    },
    methods: {
      saveReasignacion() {
        
        InventarioServices.getIdReasignacion()
          .then( rId => {

            let hoy = moment()
            let fechaReg = hoy.format('YYYY-MM-DD HH:mm:ss')
            let yy = moment(this.fechaReg).format('YY')
            let mm = moment(this.fechaReg).format('MM')
            let idReasign

            if (rId.length > 0) {
                  let idBD = (rId[0].id).toString();
                  console.log(idBD);
          
                  let countId = idBD.substr(16, 18);
                  let numAct = parseInt(countId) + 1;
                  console.log(numAct);
                  
                  switch (true) {
                    case (numAct >= 0) && (numAct < 10):
                      console.log('Mayor o igual a 0 -  Menor a 10');
                      idReasign = `GIA-REASIG-${yy}${mm}-00${numAct}`;
                      break;
                    case (numAct >= 10) && (numAct < 100):
                      console.log('Mayor o igual a 10 -  Menor a 100');
                      idReasign = `GIA-REASIG-${yy}${mm}-0${numAct}`;
                      break;
                    case (numAct >= 100):
                      console.log('Mayor o igual a 100');
                      idReasign = `GIA-REASIG-${yy}${mm}-${numAct}`;
                      break;
                    default:
                      console.log('Default');
                      // var id = `GIA-${yy}${mm}_${numAct}`;
                      break;
                  }
                } else {
                  idReasign = `GIA-REASIG-${yy}${mm}-001`;
                }

                InventarioServices.addReasignacion(idReasign, fechaReg, this.userLogin.id, this.userLogin.nombre, this.usuarioSel.id, this.usuarioSel.nombre, this.area, this.ubicacion, this.oficinaSel.id)
                  .then( rAddReasig => {
                    let i = 0
                    if (rAddReasig.success) {

                      this.items.forEach(arts => {
                        let idMov = parseInt(Date.now()) + i

                        // idArticulo, idReasignacion, serie, idResguardo, nResguarda, idRealiza, nRealiza, ubicacion, oficina, idMov, fechaReg
                        InventarioServices.updateItems_Reasignacion (arts.id_articulo, idReasign, arts.serie, this.usuarioSel.id, this.usuarioSel.nombre, this.userLogin.id, this.userLogin.nombre, this.ubicacion, this.oficinaSel.id, idMov, fechaReg)
                          .then( rItems => {
                            console.log(rItems)
                            if (rItems.success) {
                              this.itemsSaved++ 
                              setTimeout(() => {
                              console.log('Esperando')        
                              }, 326)
                            } else 
                            console.log(rItems.repsuesta)
                          })
                          .catch( e2 => console.log(e2))
                          i++
                        if (this.itemsSaved == this.items.length) {
                          console.log('Iguales debe mandar a Reasignaciones')
                          let toast = this.$toasted.show(`Se han Reasignado ${this.itemsSaved} artículos`, { 
                            theme: "toasted-primary", 
                            position: "bottom-right", 
                            duration : 3000,
                            iconPack: 'fontawesome',
                            icon: 'done',
                            action : {
                              text : 'Ok',
                              onClick : (e, toastObject) => {
                                toastObject.goAway(0)
                              }
                            },
                          })
                          this.$router.push('/Inventario/Reasignaciones')
                        } else {
                          console.log('Que pex')
                        }
                      })
                    } else {
                      console.log(rAddReasig.respuesta)
                    }
                    
                  })
                  .catch( e1 => console.log(e1))
          })
      }
    },
    computed: {
      ...mapState(['userLogin'])
    }
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/FormCambioAsignacion.vue